/**
 * Modal Module
 * モーダル機能
 */
export class Modal {
  constructor() {
    this.triggers = document.querySelectorAll('.js-modal__trigger');
    this.modals = document.querySelectorAll('.js-modal');
    this.closeButtons = document.querySelectorAll('.js-modal__close');
    this.container = document.querySelector('.c-modal__container');
    this.html = document.documentElement;
    this.isOpen = false;
    this.modalMap = new Map();
    
    if (this.triggers.length > 0 && this.modals.length > 0 && this.container) {
      this.init();
    }
  }
  
  init() {
    // モーダルをMapで管理（data-modal属性をキーに）
    this.modals.forEach((modal) => {
      const modalId = modal.getAttribute('data-modal');
      if (modalId) {
        this.modalMap.set(modalId, modal);
      }
    });
    
    // トリガーのイベント設定
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const modalId = trigger.getAttribute('data-modal');
        if (modalId) {
          this.open(modalId);
        }
      });
    });
    
    // 閉じるボタンのイベント設定
    this.closeButtons.forEach((closeBtn) => {
      closeBtn.addEventListener('click', () => this.close());
    });
    
    // 背景クリックで閉じる
    this.container.addEventListener('click', (e) => {
      if (e.target === this.container) {
        this.close();
      }
    });
    
    // ESCキーで閉じる
    this.escapeHandler = (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    };
    document.addEventListener('keydown', this.escapeHandler);
  }
  
  /**
   * 全てのモーダルを非表示
   */
  hideAllModals() {
    this.modals.forEach((modal) => {
      modal.style.display = 'none';
      modal.classList.remove('is-open');
    });
  }
  
  /**
   * モーダルを開く
   */
  open(modalId) {
    const modal = this.modalMap.get(modalId);
    if (!modal) return;
    
    this.hideAllModals();
    modal.style.display = 'block';
    this.container.style.display = 'flex';
    this.html.style.overflow = 'hidden';
    this.isOpen = true;
    
    requestAnimationFrame(() => {
      this.container.classList.add('is-open');
      modal.classList.add('is-open');
    });
  }
  
  /**
   * モーダルを閉じる
   */
  close() {
    if (!this.isOpen) return;
    
    this.container.classList.remove('is-open');
    this.hideAllModals();
    
    const handleTransitionEnd = (e) => {
      if (e.target === this.container && e.propertyName === 'opacity') {
        this.container.style.display = 'none';
        this.html.style.overflow = '';
        this.isOpen = false;
        this.container.removeEventListener('transitionend', handleTransitionEnd);
      }
    };
    
    this.container.addEventListener('transitionend', handleTransitionEnd, { once: true });
    
    setTimeout(() => {
      if (!this.container.classList.contains('is-open')) {
        this.container.style.display = 'none';
        this.html.style.overflow = '';
        this.isOpen = false;
      }
    }, 350);
  }
  
  /**
   * イベントリスナーを削除
   */
  destroy() {
    if (this.escapeHandler) {
      document.removeEventListener('keydown', this.escapeHandler);
      this.escapeHandler = null;
    }
  }
}
